/**
 * Gate de consentimento (opt-out: vale até o visitante recusar no banner) — reaproveita a MESMA chave que
 * `src/components/ui/CookieConsent.tsx` já grava no `localStorage` (script
 * inline injetado por esse componente). Nenhuma mudança no banner em si;
 * só uma leitura da mesma chave a partir de código TS normal.
 */
const CONSENT_KEY = "store-cookie-consent";
const CONSENT_DECLINED = "declined";

/**
 * Nunca lança. O guard `typeof localStorage === "undefined"` sozinho NÃO
 * bastava: em contextos reais (Safari em navegação privada historicamente,
 * escudos do Brave, políticas corporativas bloqueando dados de site) o
 * próprio *getter* `localStorage` lança `SecurityError` -- `typeof` já
 * dispara a exceção, e `getItem` pode lançar mesmo quando o getter passa.
 * Como esta função é chamada de dentro do wrapper de `dataLayer.push`, um
 * throw aqui se propagaria pelo `sendEvent()` do call-site e quebraria UI
 * real (ver Finding 2 da revisão final). Se não der pra ler o storage, não dá pra honrar uma recusa: "sem consentimento".
 */
export function hasCookieConsent(): boolean {
  try {
    if (typeof localStorage === "undefined") return false;
    return localStorage.getItem(CONSENT_KEY) !== CONSENT_DECLINED;
  } catch {
    return false;
  }
}
